var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"relative w-full flex justify-center"},[_c(_setup.OzBaseButton,{ref:"buttonRef",class:[
      // Shape
      _setup.isTouch ? 'h-11 w-11' : 'h-10 w-10',
      'rounded-lg',
      // Color
      !_vm.isSelected && _vm.colorScheme === 'dark'
        ? [
            'bg-transparent',
            'hactive:bg-light-ui-100/10',
            'hfocus-visible:ring-3',
            'hfocus-visible:ring-canary-500',
            'hfocus-visible:bg-modal-overlay-canary/20',
          ]
        : '',
      !_vm.isSelected && _vm.colorScheme === 'light'
        ? [
            'bg-transparent',
            'hactive:bg-dark-ui-100/10',
            'hfocus-visible:ring-3',
            'hfocus-visible:ring-grape-500',
            'hfocus-visible:bg-modal-overlay-grape/20',
          ]
        : '',
      _vm.isSelected && _vm.colorScheme === 'dark'
        ? ['bg-light-ui-100', 'hfocus-visible:ring-3', 'hfocus-visible:ring-canary-500']
        : '',
      _vm.isSelected && _vm.colorScheme === 'light'
        ? ['bg-dark-ui-100', 'hfocus-visible:ring-3', 'hfocus-visible:ring-grape-500']
        : '',

      // Transition
      'transition-all',
      'duration-150',
      'ease-in-out',

      // Children positioning
      'flex',
      'items-center',
      'justify-center',
      'relative',

      // Children styling
      'text-body-small',
      {
        'text-dark-text-100': _vm.colorScheme === 'dark' && _vm.isSelected,
        'text-light-text-100': _vm.colorScheme === 'light' && _vm.isSelected,
        'text-light-text-200 hhover:text-light-text-100 hactive:text-light-text-100':
          _vm.colorScheme === 'dark' && !_setup.props.disabled && !_vm.isSelected,
        'text-dark-text-200 hhover:text-dark-text-100 hactive:text-dark-text-100':
          _vm.colorScheme === 'light' && !_setup.props.disabled && !_vm.isSelected,
        'text-light-text-400': _vm.colorScheme === 'dark' && _setup.props.disabled,
        'text-dark-text-400': _vm.colorScheme === 'light' && _setup.props.disabled,
      },
    ],attrs:{"size-preset":undefined,"color-scheme":undefined,"dark-mode":_vm.colorScheme === 'dark',"label":_setup.label,"disabled":_vm.disabled},on:{"pointerenter":_setup.onPointerEnter,"focus":function($event){!_vm.disabled && _setup.onPointerEnter},"pointerleave":_setup.onPointerLeave,"blur":function($event){!_vm.disabled && _setup.onPointerLeave},"pointerup":_setup.onPointerUp,"click":_setup.onPointerDown}},[(_setup.iconName === 'attachment')?_c('span',{class:['text-body-extra-small', 'font-semibold', 'font-sans']},[_vm._v("\n      +"+_vm._s(_setup.numberOfAttachmentTypesAllowed))]):(!_setup.isSvgIcon)?_c(_setup.OzIcon,{attrs:{"font":_setup.iconName === 'camera' ? 'oricon' : 'wbicons',"name":_setup.iconName,"size":_setup.isTouch ? 26 : 24}}):_c(_setup.WhiteboardSvgIcon,{class:[
        _setup.iconColorClass,
        {
          'ms-0.5': !!_vm.secondaryMenu,
        },
      ],attrs:{"name":_setup.iconName}})],1),_vm._v(" "),_c('div',{class:[
      // Positioning
      'absolute',
      'end-0',
      'bottom-0',
      'z-sidepanel',
      // Shape
      'w-0',
      'h-0',

      // Transition
      'transition-all',
      'duration-150',
      'ease-in-out',
      'pointer-events-none',
    ],style:({
      borderColor: 'transparent',
      borderBottomColor: _setup.currentToolPreviewColorHex,
      borderStyle: 'solid',
      borderWidth: 0,
      borderInlineStartWidth: _setup.isHovered && !_vm.isSelected ? '12px' : _vm.isSelected ? '16px' : 0,
      borderBlockEndWidth: _setup.isHovered && !_vm.isSelected ? '12px' : _vm.isSelected ? '16px' : 0,
      borderRadius: 0,
      borderEndEndRadius: '6px',
    })}),_vm._v(" "),(_vm.isSelected && _setup.cornerIndicatorNeedsDiagonalLine)?_c('svg',{class:[
      'absolute',
      'end-0',
      'bottom-0',
      'z-sidepanel',
      {
        'text-dark-text-300': (_vm.colorScheme === 'dark' && _vm.isSelected) || (_vm.colorScheme === 'light' && !_vm.isSelected),
        'text-light-text-300': (_vm.colorScheme === 'light' && _vm.isSelected) || (_vm.colorScheme === 'dark' && !_vm.isSelected),
      },
      {
        '-scale-x-100': _setup.isRtl,
      },
    ],style:({
      height: _setup.isHovered && !_vm.isSelected ? '12px' : '16px',
      width: _setup.isHovered && !_vm.isSelected ? '12px' : '16px',
    }),attrs:{"viewBox":_setup.isHovered && !_vm.isSelected ? '0 0 12 12' : '0 0 16 16'}},[_c('path',{attrs:{"d":_setup.isHovered && !_vm.isSelected ? 'M 12 0 L 12 2 L 2 12 L 0 12 Z' : 'M 16 0 L 16 2 L 2 16 L 0 16 Z',"fill":"currentColor"}})]):_vm._e(),_vm._v(" "),_c(_setup.Portal,{attrs:{"selector":"#surface-container"}},[_c('Transition',{attrs:{"enter-active-class":"transition-opacity duration-250 ease-out motion-reduce:transition-none","leave-active-class":"transition-opacity duration-150 ease-in motion-reduce:transition-none","enter-class":"opacity-0","leave-to-class":"opacity-0","appear":""}},[(_vm.xTooltip && _setup.buttonEl)?_c(_setup.OzBasePopover,{class:[
          'px-3 py-1',
          'pointer-events-none',
          {
            'bg-common-ui-d70 ': _vm.colorScheme === 'dark' && _vm.colorStyle === 'frosted',
            'bg-common-ui-l86': _vm.colorScheme === 'light' && _vm.colorStyle === 'frosted',
            'bg-dark-ui-100 ': _vm.colorScheme === 'dark' && _vm.colorStyle === 'opaque',
            'bg-light-ui-100': _vm.colorScheme === 'light' && _vm.colorStyle === 'opaque',
          },
          'backdrop-blur-6',
          'z-modal',
        ],attrs:{"config":{
          placement: _setup.whiteboardStore.isLoadingPortraitMobileLayout ? 'top' : _setup.isRtl ? 'right' : 'left',
          middleware: [_setup.offset(_setup.whiteboardToolbarStore.tooltipOffset)],
        },"role":"tooltip","anchor":_setup.buttonEl,"radius":8,"color":_setup.OzBasePopoverColors.None}},[_c('span',{class:_vm.colorScheme === 'dark' ? 'text-light-text-100' : 'text-dark-text-100'},[_vm._v(_vm._s(_setup.label))]),(_setup.shortcut)?[_vm._v(" "),_c('span',{class:['ms-1.5', _vm.colorScheme === 'dark' ? 'text-light-text-300' : 'text-dark-text-300']},[_vm._v(_vm._s(_setup.shortcut)+"\n          ")])]:_vm._e()],2):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }